import '../../assets/css/pagination.css';
import '../../assets/css/perguntas-e-respostas.css';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { toastr } from 'react-redux-toastr'
import { URL } from '../../assets/js/constants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextField, Grid, Typography, Button, Box, CircularProgress } from '@material-ui/core';

import { getFuncionarios } from '../../store/actions/funcionario';
import { getListaPerfilAdmin, atualizarPerfilUsuarioAdmin } from '../../store/actions/usuario';
import { getPerguntasPorNegocio } from '../../store/actions/pergunta';
import formatarDataHora from '../../assets/js/formatarDataHora';
import TituloPagina from '../../components/layout/TituloPagina';
import DialogAlert from '../../components/layout/DialogAlert';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const Perguntas = props => {
    const {
        user,
        negocioDoUsuario
    } = props;

    const linesPerPage = 10;
    const direction = 'DESC';
    const orderBy = 'dataCriacao';

    const [perguntas, setPerguntas] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [conteudoResposta, setConteudoResposta] = useState('');
    const [errorConteudoResposta, setErrorConteudoResposta] = useState(false);
    const [msgErrorConteudoResposta, setMsgErrorConteudoResposta] = useState('');
    const [toggleResponderDialog, setToggleResponderDialog] = useState(false);
    const [perguntaRespondida, setPerguntaRespondida] = useState({});
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');

    useEffect(() => {
        loadPerguntas(0);
    }, [])

    async function loadPerguntas(pageIndex = 0) {
        setLoading(true);
        try {
            const response = await axios.get(
                `${URL}/duvidas/vendedor/page?idNegocio=${negocioDoUsuario}&page=${pageIndex}&linesPerPage=${linesPerPage}&direction=${direction}&orderBy=${orderBy}`
            );

            const { data } = response;

            if (!data || typeof data.totalPages === 'undefined' || !Array.isArray(data.content)) {
                console.error('Resposta inválida:', data);
                return;
            }

            setPerguntas(data.content);
            setPage(data.number); // número da página atual
            setTotalPages(data.totalPages);
        } catch (error) {
            console.error('Erro ao carregar perguntas:', error);
        } finally {
            setLoading(false);
        }
    }

    // callback do ReactPaginate
    function handlePageClick(event) {
        const selectedPage = event.selected; // índice da página clicada
        loadPerguntas(selectedPage);
    };

    function handleResponder(pergunta) {
        setPerguntaRespondida(pergunta);
        setToggleResponderDialog(true);
    }

    async function handleEnviarResposta() {
        setProcessingMessage('Salvando...');
        setIsProcessing(true);

        const data = { idPergunta: perguntaRespondida.id, idUsuario: user.id, idNegocio: negocioDoUsuario, conteudo: conteudoResposta };
        try {
            await axios.post(`${URL}/duvidas/resposta`, data);

            setToggleResponderDialog(false);
            setConteudoResposta({});
            loadPerguntas();

            setInterval(() => {
                window.location.reload();
            }, 3000);

            setIsProcessing(false);
            setProcessingMessage('');
            toastr.success('Sucesso', 'Resposta enviada com sucesso.');
        } catch (e) {
            setIsProcessing(false);
            setProcessingMessage('');
            toastr.error('Erro', e.message);
        }
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Perguntas e Respostas' subtitulo={new Date().toLocaleString('pt-BR')} />

            {
                perguntas.length > 0
                    ?
                    perguntas?.map((p) => (
                        <div key={p.id} class='pergunta-card'>
                            <div class='pergunta'>
                                <p class='produto'>{p.produto}</p>
                                <h3>Pergunta</h3>
                                <p>{p.conteudo}</p>
                                <p class='data'>Criada em {p.dataCriacao} por {p.autor}.</p>
                            </div>
                            {p.resposta != null ?
                                <div class='resposta'>
                                    <h4>Resposta</h4>
                                    <p>{p.resposta.conteudo}</p>
                                    <p class='data'>Respondida em: {p.resposta.dataCriacao}</p>
                                    <p class='funcionario'>Funcionário responsável: {p.resposta.matriculaFuncionario} {p.resposta.nomeFuncionario}</p>
                                </div>
                                :
                                <Button variant='contained' color='secondary' onClick={() => handleResponder(p)}>Responder</Button>
                            }
                        </div>
                    )
                    )
                    :
                    <Box sx={{ height: '70vh' }}>
                        <h3 style={{ textAlign: 'center' }}>Você não recebeu nenhuma pergunta até o momento.</h3>
                    </Box>
            }

            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={10}
                onPageChange={handlePageClick}
                forcePage={page} // mantém sincronizado com backend
                renderOnZeroPageCount={null}
                containerClassName={'pagination'}      // classe do UL
                pageClassName={'page-item'}            // classe de cada LI
                pageLinkClassName={'page-link'}        // classe do link dentro do LI
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                breakClassName={'break'}
                breakLinkClassName={'page-link'}
                activeClassName={'active'}             // classe aplicada ao LI ativo
                disabledClassName={'disabled'}         // classe aplicada quando não há anterior/próximo
            />

            <DialogAlert
                openDialog={toggleResponderDialog}
                title='Escreva sua melhor resposta!'
                fullWidth={true}
                maxWidth='sm'
                okButton={true}
                okButtonType='submit'
                okButtonClick={handleEnviarResposta}
                labelOkButton='Confirmar'
                cancelButton={true}
                labelCancelButton='Cancelar'
                cancelButtonClick={() => setToggleResponderDialog(false)}
            >
                <Grid item style={{ paddingBottom: '15px' }}>
                    <Typography variant="body1" ><strong>PRODUTO:</strong></Typography>
                    <Typography variant="body1" >{perguntaRespondida.produto}</Typography>
                </Grid>
                <Grid item >
                    <Typography variant="body1" ><strong>PERGUNTA:</strong></Typography>
                    <Typography variant="body1" >{perguntaRespondida.conteudo}</Typography>
                </Grid>
                <Grid item style={{ paddingTop: '15px' }}>
                    <TextField
                        multiline
                        rows={4}
                        variant='outlined'
                        color='secondary'
                        fullWidth
                        id='resposta'
                        name='resposta'
                        label='Resposta'
                        value={conteudoResposta}
                        onChange={(event) => {
                            setConteudoResposta(event.target.value);
                            setErrorConteudoResposta(false);
                            setMsgErrorConteudoResposta('');
                        }}
                        error={errorConteudoResposta}
                        helperText={msgErrorConteudoResposta}
                        type={'text'}
                    />
                </Grid>
            </DialogAlert>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={processingMessage}
            />
        </>
    );

}

const mapStateToProps = state => ({
    user: state.auth.user,
    funcionarios: state.funcionario.funcionarios,
    listaPerfilAdmin: state.usuario.listaPerfilAdmin,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getFuncionarios,
    getListaPerfilAdmin,
    atualizarPerfilUsuarioAdmin,
    getPerguntasPorNegocio,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Perguntas);